module.exports = __webpack_public_path__ + "images/external_images/svg/mockups/mobile-apps-illustration.svg";